<template lang="pug">
  .panel-body
    .my-2
      cite Planos que disponibilizam este curso
    .divider
    .plan(v-for="plan in plans" v-if="plans.length > 0")
      .columns.align-center
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ plan.title }}
          .text-small.text-ellipsis {{ plan.description }}
        .column.col-auto
          .h5.text-bold.text-error {{ plan.price | currency('R$ ') }}
    .empty(v-else)
      .empty-icon
        i.fas.fa-frown.fa-3x
      p.empty-title.h5 Ops
      p.empty-subtitle Este curso ainda não está disponível em nenhum plano

</template>

<script>
export default {
  props: { plans: { type: Array, required: true } },
}
</script>
